export const UPDATE_SELLER_WALLET_PLAN_REQUEST = "UPDATE_SELLER_WALLET_PLAN_REQUEST";
export const UPDATE_SELLER_WALLET_PLAN_SUCCESS = "UPDATE_SELLER_WALLET_PLAN_SUCCESS";
export const UPDATE_SELLER_WALLET_PLAN_FAILURE = "UPDATE_SELLER_WALLET_PLAN_FAILURE";
export const UPDATE_SELLER_WALLET_PLAN_RESET = "UPDATE_SELLER_WALLET_PLAN_RESET";
export const updateSellerWalletPlanRequest = (payload) => ({
    type: UPDATE_SELLER_WALLET_PLAN_REQUEST,
    payload,
});
export const updateSellerWalletPlanSuccess = (payload) => ({
    type: UPDATE_SELLER_WALLET_PLAN_SUCCESS,
    payload,
});
export const updateSellerWalletPlanFailure = (payload) => ({
    type: UPDATE_SELLER_WALLET_PLAN_FAILURE,
    payload,
});
export const updateSellerWalletPlanReset = () => ({
    type: UPDATE_SELLER_WALLET_PLAN_RESET,
});
